import { render, staticRenderFns } from "./ViewSaleReturn.vue?vue&type=template&id=06971bb6&"
import script from "./ViewSaleReturn.vue?vue&type=script&lang=js&"
export * from "./ViewSaleReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports